var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z",
    fill: "#FB7B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.2651L8 5.73341C8.0002 5.60164 8.03342 5.47236 8.09616 5.3591C8.1589 5.24585 8.24886 5.1528 8.35661 5.0897C8.46436 5.0266 8.58594 4.99578 8.7086 5.00046C8.83126 5.00515 8.95049 5.04516 9.05379 5.11632L16.6849 10.3807C16.7815 10.4472 16.861 10.5387 16.9161 10.6467C16.9711 10.7548 17 10.8761 17 10.9993C17 11.1225 16.9711 11.2437 16.9161 11.3518C16.861 11.4599 16.7815 11.5514 16.6849 11.6178L9.05379 16.8837C8.95049 16.9548 8.83126 16.9949 8.7086 16.9995C8.58594 17.0042 8.46436 16.9734 8.35661 16.9103C8.24886 16.8472 8.1589 16.7541 8.09616 16.6409C8.03342 16.5276 8.0002 16.3984 8 16.2666V16.2651Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.d855391047384d016ff6db93e098475e.svg";
export { ForwardRef as ReactComponent };